






























































import WachtwoordInput from "../../components/WachtwoordInput.vue";
import { apiClient } from "../../services/api-client";
import BasePage from "@/components/Base/BasePage.vue";
import { errorHandlingApiResponse } from "@/mixins/errorHandlingApiResponse";

export default {
  name: "WachtwoordWijzigen",
  mixins: [errorHandlingApiResponse],
  components: { BasePage, WachtwoordInput },
  data() {
    return {
      password: "",
      isValidated: false,
      passwordHidden: true
    };
  },
  methods: {
    submit() {
      apiClient
        .wachtwoordWijzigen({
          wachtwoord: this.password
        })
        .then(() => {
          this.$store.dispatch("snackbarAdded", {
            text: this.$t("WachtwoordWijzigen.success"),
            type: "success"
          });
          this.$router.push({ name: "Home" });
        })
        .catch(error => {
          errorHandlingApiResponse.methods.getSnackbarText(error.status);
        });
    },

    invertPasswordHidden() {
      this.passwordHidden = !this.passwordHidden;
    }
  }
};
